import { IconBase, IconComponent } from './BaseIcon';

export const Drop: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="m16.95 3.11-.74-1-.75 1c-.34.46-8.27 11.42-8.27 18a9 9 0 0 0 18 0c.01-6.46-7.91-17.53-8.24-18Zm-.76 25.14A7.18 7.18 0 0 1 9 21.08c0-4.85 5.2-12.93 7.18-15.82 2 2.91 7.17 11.06 7.17 15.83a7.18 7.18 0 0 1-7.16 7.16Zm3.29-8.95a1.1 1.1 0 0 0-1.1 1.1 3 3 0 0 1-2.94 2.94 1.1 1.1 0 0 0 0 2.2 5.15 5.15 0 0 0 5.15-5.14 1.1 1.1 0 0 0-1.11-1.1Z" />
  </IconBase>
);
